import { useState, useEffect } from 'react';
import { Home, Image, MapPin, CalendarCheck, Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const MobileBottomNav = () => {
    const { t } = useTranslation();
    const [activeSection, setActiveSection] = useState('home');

    const navItems = [
        { id: 'hero', icon: Home, label: 'Home' },
        { id: 'photos', icon: Image, label: t('nav.photos') || 'Photos' },
        { id: 'amenities', icon: Coffee, label: t('nav.amenities') || 'Amenities' },
        { id: 'location', icon: MapPin, label: t('nav.location') || 'Location' },
        { id: 'book', icon: CalendarCheck, label: t('nav.book') || 'Book' },
    ];

    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setActiveSection(id);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = navItems.map(item => item.id);
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-t border-gray-200 pb-safe md:hidden transition-transform duration-300">
            <div className="flex justify-around items-center h-16 px-2">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeSection === item.id;

                    return (
                        <button
                            key={item.id}
                            onClick={() => scrollToSection(item.id)}
                            className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors duration-200 ${isActive
                                ? 'text-primary-600'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            <Icon
                                size={20}
                                className={`transition-transform duration-200 ${isActive ? 'scale-110' : 'scale-100'
                                    }`}
                                strokeWidth={isActive ? 2.5 : 2}
                            />
                            <span className="text-[10px] font-medium leading-none">
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileBottomNav;
